import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import axios from 'axios';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import { PageTitle, scrollToTopValidate, scrollToTop } from "../Helpers/SettingHelper";
import {  apiUrl,doctorURL } from '../Config/Config';
import Multiselect from 'multiselect-react-dropdown';

import PlacesAutocomplete, {
	geocodeByAddress,
	getLatLng,
  }  from 'react-places-autocomplete';

class Edit extends Component {

	constructor(props)
	{
		super(props);	
		const id = (typeof this.props.match.params.ID === 'undefined') ? '' : this.props.match.params.ID;

		this.state = {
			id: id,
			name:'',
			email:'',
			phoneno:'',
			status:'',
			description: '',
			selectedDomain:'',
			domainlist:[],
			specialist:[],
			selectedOption:{ value: 'active', label: 'Active'},
			selectedvalue:'',
			domain_id:'',
			specialist_id:'',
			specialistvlue:'',
			dont_distrub_checked:false,
			certificate_verified_checked:false,
			image:'',
			image2:'',
			image_name: '',
			image_preview: '',
			name_img1:'',
			preview1:'',
			locationlist: [{id: '', name: 'Select Your Location'}],
			locationselectedList:[],
			avalibility:''
					
		};
		
	   this.handleInputChange = this.handleInputChange.bind(this);
	  
	   this.handleChange = this.handleChange.bind(this);
	   this.onChangeHandler = this.onChangeHandler.bind(this);
    }

   handleInputChange(event) {

      const {name, value} = event.target;      
      this.setState({
          [name]: value
        });
		if(name == 'dont_distrub'){
			this.setState({dont_distrub_checked: !this.state.dont_distrub_checked})
		}
		if(name == 'certificate_verified'){
			this.setState({certificate_verified_checked:!this.state.certificate_verified_checked})
		}


    }
     handleChange = selectedOption => {
        this.setState({selectedOption})
        this.setState({  selectedvalue : selectedOption.value});
    };
	onChangeHandler=event=>{
		let reader = new FileReader();
		const file = event.target.files[0];
		reader.onloadend = () => {
		  this.setState({
			image_name: file.name,
			image_preview: reader.result,
			image: file
		  });
		};
		reader.readAsDataURL(file);
	}
	componentDidMount() {
		document.title = PageTitle('user Edit');
		if(localStorage.getItem('admin_id') === null){
		this.props.history.push('/');
		}

		axios.get(apiUrl+'doctor/listdetail?id='+this.state.id)
		
		.then(res => {
			if(res.data.status == 'success'){
			
					const formdata = res.data.doctordata;
				
					// this.setState({ });

					// locationselectedValue:[{id: '1', name: 'Japan, Fukuoka, Chuo Ward, Izaki, 4, SSDS'},{id: '3', name: 'Mexico'}]	

					if(res.data.locationlist!=undefined && res.data.locationlist!=''  ){					
						this.setState({locationselectedValue:res.data.locationlist});
					}

					if(formdata.status === 'A'){
						this.setState({selectedOption:{value: 'active', label: 'Active'},selectedvalue:'active'});
					}else{
						this.setState({selectedOption:{value: 'inactive', label: 'Inactive'},selectedvalue:'inactive'});
					}
					if(parseInt(formdata.dont_distrub) === 0){
						this.setState({dont_distrub_checked: false});
					}else{
						this.setState({dont_distrub_checked: true});
					}
					if(formdata.certificate_verified =='No'){
						this.setState({certificate_verified_checked:false});
					}else{
						this.setState({certificate_verified_checked:true});
					}
					var specialist_id='';
					if(formdata.specialist!=undefined ){					
						specialist_id = formdata.specialist;
					}
					this.setState({image_preview:formdata.image,name:formdata.name,email:formdata.email,phoneno:formdata.phone,id: formdata.id, graduation: formdata.graduation,experience: parseInt(formdata.experience_yr),fee: parseInt(formdata.consultant_fee),location: formdata.location, description: formdata.description,domain_id: res.data.domaindata[0].value,specialist_id: specialist_id,avalibility:formdata.avalibility});		
					let Img1 = '';
					let preview1 = '';
					if (formdata.certificate!== null && formdata.certificate!== '') {
						Img1 = doctorURL + "/" + formdata.certificate;
						preview1 =<a href={Img1} className="preview-img" target='_blank'><img className="img_class" style={{width:'70px',height:'70px'}} src={Img1} alt="" /></a>;
						this.setState({name_img1:formdata.certificate})
					}else{
						this.setState({name_img1:''})
					} 
					this.setState({
						preview1:preview1
					});
				}else{
			
			}
		});

		var admin_id = localStorage.getItem('admin_id');
		axios.get(apiUrl+'doctor/getdomainlist?admin_id='+admin_id)
		
		.then(res => {
			if(res.data.status == 'success'){
			
				this.setState({
					domainlist: [{value: '', label: 'Select Your Domain'}].concat(res.data.domainlist)
				})
			
			}else{
			
			}
		});

		axios.get(apiUrl+'doctor/getspecialist?admin_id='+admin_id)
		
		.then(res => {
			if(res.data.status == 'success'){
			
				this.setState({
					specialist: [{value: '', label: 'Select Your Specialist'}].concat(res.data.specialist)
				})
			
			}else{
			
			}
		});

		axios.get(apiUrl+'doctor/getlocation?admin_id='+admin_id)		
		.then(res => {
			if(res.data.status == 'success'){
			
				this.setState({
					locationlist: [].concat(res.data.location)
				})
			
			}else{
			
			}
		});	
    }

	handleFormSubmit = () => {
		if(this.validateForm()){
			this.setState({Loading:true});
			var qs = require('qs');
			const formPayload = this.state;
			var status = '';
			var dontditrub = 0;
			var certificate = 'NO';
			if(this.state.dont_distrub_checked == true){
				var dontditrub = 1;
			}
			if(this.state.certificate_verified_checked == true){
				certificate ='Yes';
			}
			const locationselectedList = formPayload.locationselectedList;
			var elements=[];
			var elements1=[];
			let locList  = ''
			if(locationselectedList!=='' && typeof locationselectedList!==undefined && locationselectedList!==null) {
				locList = locationselectedList.map((number) =>
					elements.push(number.id)					
				);
				locList = locationselectedList.map((number) =>
					elements1.push(number.name.replace(/[,]/g,' '))
				);
			}		
			const locationselectedLists=elements.toString();
			const locationselectedLists1=elements1.toString();

			var postObject = {
				admin_id : localStorage.getItem("admin_id"),
				id: formPayload.id,
				domain_id : formPayload.domain_id,
				name     : formPayload.name,
				graduation: formPayload.graduation,
				specialist    : formPayload.specialist_id,
				experience_yr     : formPayload.experience,
				email        : formPayload.email,
				phoneno      : formPayload.phoneno,
				location: formPayload.location,
				image: formPayload.image,
				consultant_fee: formPayload.fee,
				dont_distrub: dontditrub,
				certificate_verified: certificate,
				description: formPayload.description,
				status       :  formPayload.selectedvalue,
				locationselectedid:locationselectedLists,
				locationselectedname:locationselectedLists1,
				avalibility:formPayload.avalibility
			};
			let formData = new FormData();
			for(let k in postObject) {
				formData.append(k, postObject[k]);
			}
			axios.post(apiUrl+"doctor/edit",formData).then(res => {

				if(res.data.status === "success"){	

					const formdata = res.data.doctorlist;
					
					if(formdata.status === 'A'){
						this.setState({selectedOption:{value: 'active', label: 'Active'},selectedvalue:'active'});
					}else{
						this.setState({selectedOption:{value: 'inactive', label: 'Inactive'},selectedvalue:'inactive'});
					}

					if(parseInt(formdata.dont_distrub) === 0){
						this.setState({dont_distrub_checked: false});
					}else{
						this.setState({dont_distrub_checked: true});
					}
					if((formdata.certificate_verified) == 'No'){
						this.setState({certificate_verified_checked: false});
					}else{
						this.setState({certificate_verified_checked: true});
					}

					this.setState({image_preview:formdata.image,name:formdata.name,email:formdata.email,phoneno:formdata.phone,id: formdata.id, graduation: formdata.graduation,experience: parseInt(formdata.experience_yr),fee: parseInt(formdata.consultant_fee),location: formdata.location, description: formdata.description,specialist_id: res.data.specialist[0].value,domain_id: res.data.domaindata[0].value});		

					$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');

					scrollToTop();
						setTimeout(
						function() {
							$('.success_message').html('');
						}
						.bind(this),
						3000
						);
				}else{
					
				}
			});
		}
	}

	validateForm() {
		const {name,email,phoneno,domain_id,specialist_id,location,fee,experience,graduation,avalibility} = this.state;
		let errors = 0;

		if(!name) {
			errors++;
			$('.errorname').html('<span class="errorspan">Please fill the field</span>');
		}else if(name){
			$('.errorname').html('');
		}

		if(!avalibility) {
			errors++;
			$('.erroravalibility').html('<span class="errorspan">Please fill the field</span>');
		}else if(avalibility){
			$('.erroravalibility').html('');
		}


		if (!domain_id) {
			errors++;
			$('.errorassign_domain').html('<span class="errorspan">Please select the field</span>');
		}else if(domain_id){
			$('.errorassign_domain').html('');
		}

		if (!specialist_id) {
			errors++;
			$('.errorspecialist').html('<span class="errorspan">Please select specialist</span>');
		}else if(specialist_id){
			$('.errorspecialist').html('');
		}

		if (!graduation) {
			errors++;
			$('.errorgraduation').html('<span class="errorspan">Please fill the field</span>');
		}else if(graduation){
			$('.errorgraduation').html('');
		}
		if (!email) {
	    	errors++;			
			$('.erroremail').html('<span class="errorspan">Please fill the field</span>');
		}else if(email){
			var reg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
		    // var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
		    if (reg.test(email) == false) 
	        {
				errors++;				
	            $('.erroremail').html('<span class="errorspan">Please enter valid email address</span>');
	        }else{
	        	$('.erroremail').html('');
	        }
		}
		if (!phoneno) {
			errors++;
			$('.errorphoneno').html('<span class="errorspan">Phone number is required</span>');
		  }else if(phoneno){	
			 var pattern = /^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
			 var indiapattern =/^([0|\+[0-9]{1,5})?([7-9][0-9]{9})$/;
			    if (pattern.test(phoneno)) {
				$('.errorphoneno').html('');
				}else if(indiapattern.test(phoneno)){
				$('.errorphoneno').html('');
				}else{
					 errors++;
					 $('.errorphoneno').html('<span class="errorspan">Please enter valid phone number</span>');
				   }
		}	

		if (!location) {
			errors++;
			$('.errorlocation').html('<span class="errorspan">Please fill the field</span>');
		}else if(location){
			$('.errorlocation').html('');
		}

		if (!fee) {
			errors++;
			$('.errorfee').html('<span class="errorspan">Please fill the field</span>');
		}else if(fee){
			$('.errorfee').html('');
		}
		if (!experience) {
			errors++;
			$('.errorexperience').html('<span class="errorspan">Please fill the field</span>');
		}else if(experience){
			$('.errorexperience').html('');
		}
		
		if(errors>0) {
		setTimeout(function () {
		scrollToTopValidate();
		}, 100);
		return false;
		}
		else {
		return true;
		}

		/*this.setState({
			errors: errors
		});
		return formIsValid;*/
    }

	  handleClickSelecet = (event) => {
		const selectedIndex = event.target.options.selectedIndex;
		var key = event.target.options[selectedIndex].getAttribute('data-key');

		this.setState({
				domain_id: key,
				
		})


	}

	handlespecialist = (event) => {


		const selectedIndex = event.target.options.selectedIndex;
		var key = event.target.options[selectedIndex].getAttribute('data-key');

		this.setState({
			specialist_id: key,
				
		})
	}
	handleChangeaddress = location => {
		this.setState({ location });
	  };
	 
	  handleSelect = location => {

		geocodeByAddress(location)
		  .then(results => getLatLng(results[0]))
		  .then(latLng => console.log('Success', latLng))
		  .catch(error => console.error('Error', error));


		  this.setState({ location });
		//   console.log(results,'results[0]')
	  };

	  	onSelect = selectedList=>{		
			console.log(selectedList,'selectedList')
			this.setState({locationselectedList:selectedList});		
		}
		
		onRemove = selectedList =>{
			this.setState({locationselectedList:selectedList});	
		}

  render() {
  	const {preview1, name_img1,selectedOption,specialist,domainlist,image2} = this.state;
	let loaderimg = '';
	let preview = '';
	  var current = this;
	  let extension = '';
	  
	  if(name_img1!=''){
		var str = name_img1;
		var test = str.match(/(.+)\.(.+)/);
		var filename = test[1];
		 extension = test[2];
		if(extension == 'pdf'){
			let	preview1 = <a href={doctorURL + "/" + name_img1}  target='_blank'>preview pdf</a>	
		}
	   }


	  const imagepre = doctorURL+'/'+this.state.image_preview;
	
	  if (this.state.id!=='' && imagepre!== null && imagepre!== '') {
		  loaderimg = doctorURL + '/'+this.state.image_preview;
		  preview = <img className="img_class" src={loaderimg} alt="" />;
		// alert('hh');
	  }else{
		  preview = <img className="img_class" src={imagepre} alt="" />;
	  }


    return (
      <div className="wrapper"> 
 
	  <Header />
    <MenuSidebar currentpage="doctors" />  	
	<div className="content">	
		<div className="content-wrapper">
		         <div class="content-wrapper-before"></div>
			<div className="form-wrapper leaa-admin-head card">
			<div className="success_message"></div>
			<div>
				<a className="cursor-pointer btn-arrow" href="/doctors">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800.48 613.46"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(-1 0 0 -1 800.48 613.46)"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(0 -1 1 0 -199.77 906.72003)"><path d="m857.14 640.38-221.02 225.27-4.25-665.88-65.172 1.4141-1.418 667.3-223.85-226.68-48.172 48.172 306.02 310.27 307.44-311.69z" fillRule="evenodd"/></g></g></svg>
				</a>
			</div>
			<div className="title">
				<h4>Edit Details</h4>
				
			</div>
			 <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} encType="multipart/form-data" >
			 <div className="form-row">
				<div className="form-left">
					<div className="form-group">
						<label>Doctor Name<span class="required" style={{ color: "red" }} > * </span>:</label>
						<input type="text" name="name" onChange={this.handleInputChange} className="form-control" value={this.state.name} />
						<div className="errorname"></div>
					</div>
					
					<div className="form-group">
						<label>Phone number<span class="required" style={{ color: "red" }} > * </span>:</label>
						<input type="text" name="phoneno" onChange={this.handleInputChange} className="form-control" value={this.state.phoneno} />
						<div className="errorphoneno"></div>
					</div>
					<div className="form-group">					
							<label>Specialist<span class="required" style={{ color: "red" }} > * </span>: </label>
							<select  onChange={current.handlespecialist} value={this.state.specialist_id}>                    
							{this.state.specialist.map((specialist) => <option key={specialist.value} data-key={specialist.value} value={specialist.value} > {specialist.label} </option>)}
							</select>	
							<div className="errorspecialist"></div>
						</div>
					<div className="form-group">
							<label>Years of experience<span class="required" style={{ color: "red" }} > * </span>:</label>
							<input type="text" name="experience" onChange={this.handleInputChange} className="form-control" value={this.state.experience} autoComplete="off"/>
							<div className="errorexperience"></div>
					</div>

					
				   <div className="form-group">					
						<label>About Us:</label>
							<textarea type="text" name="description" onChange={this.handleInputChange} className="form-control" value={this.state.description}  />
						<div className="errordescription"></div>
				   </div>
				   
				   <div className="form-group">		
						<label>Availability<span class="required" style={{ color: "red" }} > * </span>:</label>
						<input type="text" name="avalibility" onChange={this.handleInputChange} className="form-control" value={this.state.avalibility} autoComplete="off"/>
						<div className="erroravalibility"></div>
				   </div>

				   <div className="form-group">
							<input onChange={this.handleInputChange} type="checkbox"  name="dont_distrub" checked={this.state.dont_distrub_checked}/>
							<label> Don't distrub </label>
						</div>
						<div className="form-group">
						<label>Icon:</label>
						<div className="choose-file">
						{this.state.isHidden && <div className="image_success"></div>}
						<span className="profile_btn"><input type="file" name="file" onChange={this.onChangeHandler} /></span>
						</div>
						{preview}
					
						<div className="errorloaderimage"></div>  
					</div> 
				</div>
				<div className="form-right">
					  <div className="form-group">
							<label>Email<span class="required" style={{ color: "red" }} > * </span>:</label>
								<input type="text" name="email" onChange={this.handleInputChange} className="form-control" value={this.state.email} autoComplete="off" />
							<div className="erroremail"></div>
						</div>

						<div className="form-group">
							<label>Graduation<span class="required" style={{ color: "red" }} > * </span>:</label>
							<input type="text" name="graduation" onChange={this.handleInputChange} className="form-control" value={this.state.graduation} autoComplete="off"/>
							<div className="errorgraduation"></div>
					    </div>

						<div className="form-group">					
							<label>Assign Domain<span class="required" style={{ color: "red" }} > * </span>: </label>
							<select  onChange={current.handleClickSelecet}  value={this.state.domain_id}>                    
							{this.state.domainlist.map((domainlist) => <option key={domainlist.value} data-key={domainlist.value} value={domainlist.value} >{domainlist.label}</option>)}
							</select>	
							<div className="errorassign_domain"></div>
						</div>
						
						<div className="form-group">
							<label>Consultant Fee<span class="required" style={{ color: "red" }} > * </span>:</label>
							<input type="text" name="fee" onChange={this.handleInputChange} className="form-control" value={this.state.fee} autoComplete="off"/>
							<div className="errorfee"></div>
					    </div>

						{/* <div className="form-group">
							<label>Location:</label>
							<input type="text" name="location" onChange={this.handleInputChange} className="form-control" value={this.state.location} autoComplete="off"/>
							<div className="errorlocation"></div>
					    </div> */}
						<div className="form-group">
						<label>Location<span class="required" style={{ color: "red" }} > * </span>:</label>
							<PlacesAutocomplete	value={this.state.location}	onChange={this.handleChangeaddress}	onSelect={this.handleSelect}			>
								{({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
								<div>
									<input  type="text" name="location" className="form-control" value={this.state.location}	
									{...getInputProps({
										placeholder: 'Search Places ...',
										className: 'location-search-input',
									})}
									/>
									<div className="autocomplete-dropdown-container">
									{loading && <div>Loading...</div>}
									{suggestions.map(suggestion => {
										const className = suggestion.active
										? 'suggestion-item--active'
										: 'suggestion-item';
										// inline style for demonstration purpose
										const style = suggestion.active
										? { backgroundColor: '#fafafa', cursor: 'pointer' }
										: { backgroundColor: '#ffffff', cursor: 'pointer' };
										return (
										<div
											{...getSuggestionItemProps(suggestion, {
											className,
											style,
											})}
										>
											<span>{suggestion.description}</span>
										</div>
										);
									})}
									</div>
								</div>
								)}
							</PlacesAutocomplete>
							<div className="errorlocation"></div>
					    </div>
						<div className="form-group">
							<label>Preferred Location:</label>
							<Multiselect
							options={this.state.locationlist} // Options to display in the dropdown
							 selectedValues={this.state.locationselectedValue} 
							 // Preselected value to persist in dropdown
							onSelect={this.onSelect} // Function will trigger on select event
							onRemove={this.onRemove} // Function will trigger on remove event
							displayValue="name" // Property name to display in the dropdown options
							/>
					    </div>

						<div className="default-font">
							<div className="form-group">					
								<label>Status:</label>
									<Select 
									value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
										options={lang.common.status_option} 
										onChange={this.handleChange}
										/>
							</div>
						</div>
						{(name_img1 !== '') && <div className="form-group">
							<label>Certificate:</label>
							<div className="preview-img">
								{((extension != 'pdf')&&(extension!=''))?<div className="preview-img"><div className="img">{preview1}</div>
										{preview1 !== '' ? '' : '' }	
									  </div> : <> {(name_img1 !== '') ?  <div className="preview-img pdf-icon"><div className="img"><a className="icon" href={doctorURL + "/" + name_img1} id='img_1' target='_blank'>
									  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M27.928 42.848a3.48 3.48 0 0 0-1.168-.976c-.47-.245-1.03-.368-1.68-.368a3.25 3.25 0 0 0-1.408.304c-.427.203-.779.528-1.056.977h-.032v-1.057h-2.16v11.169h2.273v-3.921h.032c.277.406.632.713 1.064.921.432.207.904.312 1.416.312.608 0 1.139-.117 1.592-.352.453-.235.832-.55 1.136-.944a4.07 4.07 0 0 0 .68-1.36 5.695 5.695 0 0 0 .224-1.6c0-.587-.075-1.149-.224-1.688a4.15 4.15 0 0 0-.689-1.417zm-1.456 4.016c-.064.319-.174.6-.328.84-.155.24-.357.435-.608.584-.251.149-.563.224-.936.224-.363 0-.672-.074-.928-.224a1.789 1.789 0 0 1-.616-.584 2.516 2.516 0 0 1-.336-.84 4.56 4.56 0 0 1-.104-.977c0-.341.032-.672.096-.991.064-.32.173-.603.328-.849.154-.245.357-.445.608-.6.25-.154.562-.232.936-.232.363 0 .669.078.92.232.251.154.456.357.616.607.16.251.274.536.344.856.069.32.104.645.104.976 0 .333-.032.658-.096.978zm5.44-5c-.459.239-.84.558-1.144.952a4.178 4.178 0 0 0-.688 1.367 5.579 5.579 0 0 0-.232 1.608c0 .576.077 1.131.232 1.664.154.533.384 1.006.688 1.416.304.411.69.736 1.16.976.469.24 1.014.36 1.632.36a3.49 3.49 0 0 0 1.464-.296c.432-.197.781-.521 1.048-.968h.032V50h2.16V38.576h-2.272v4.16h-.032a2.445 2.445 0 0 0-1.048-.92 3.256 3.256 0 0 0-1.4-.312c-.608 0-1.141.12-1.6.36zm3.136 1.576c.245.149.445.344.6.584.154.239.264.517.328.832.064.314.096.643.096.983 0 .342-.032.672-.096.992a2.7 2.7 0 0 1-.32.856c-.15.25-.349.45-.6.6-.251.149-.563.224-.936.224-.352 0-.654-.077-.904-.231a1.978 1.978 0 0 1-.624-.608 2.609 2.609 0 0 1-.36-.856 4.2 4.2 0 0 1-.112-.96c0-.342.034-.67.104-.984.069-.315.181-.595.336-.84.154-.245.36-.442.616-.592.256-.149.571-.225.944-.225.373.001.682.076.928.225zM40.472 50h2.272v-6.752h1.568v-1.521h-1.568v-.495c0-.342.067-.584.2-.729.133-.143.354-.216.664-.216.288 0 .565.016.832.048V38.64c-.192-.01-.39-.023-.592-.04a7.72 7.72 0 0 0-.608-.023c-.928 0-1.622.234-2.08.704-.458.469-.688 1.071-.688 1.808v.64h-1.36v1.521h1.36V50z"/><path d="M36 2H12v60h40V18L36 2zm14 58H14V4h20v16h16v40z"/></svg>
										
										</a></div><span className="file-name">{name_img1}</span></div>: '' } </> } 
							</div> 
						
							<input onChange={this.handleInputChange} type="checkbox"  name="certificate_verified" checked={this.state.certificate_verified_checked}/>
							<label> Certificate Verified	 </label>
						</div>}
						
					</div>
				</div>

			<div className="btn-group export">	
				   <button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true ?
                                        <span>Loading</span>:<span>Submit</span> 
                                        }
                   </button>
			</div>
			</form>
			</div>
				
		</div>	
	</div>
		 	
    </div>
    );
  }
}

export default (withRouter(Edit));